import theme from '@/style';
import React, {ReactNode} from 'react';
import {StyleProp, View, ViewStyle} from 'react-native';
import {useInnerStyle} from '../proxy.hooks';
import Text from '@basicComponents/text';
import rulesstyles from './rule.module.scss';

export interface ProxyRulesTableProps {
  titles: string[];
  results: (string | ReactNode)[][];
  colStyles?: StyleProp<ViewStyle>[];
  style?: StyleProp<ViewStyle>;
}

const ProxyRulesTable: React.FC<ProxyRulesTableProps> = props => {
  const {rulesStyle} = useInnerStyle();
  const {titles, results, style} = props;
  // const resultColStyles = useMemo(() => {
  //   if (!colStyles) {
  //     return Array(titles.length)
  //       .fill(0)
  //       .map(() => null);
  //   }
  //   return colStyles;
  // }, [colStyles, titles.length]);
  // 如果列少的话就平分宽度，而不是写死宽度
  return (
    <View style={[theme.flex.col, style]}>
      <View
        style={[
          rulesStyle.tableHead,
          theme.flex.row,
          theme.flex.between,
          theme.flex.centerByCol,
          theme.padding.s,
        ]}>
        {titles.map((title, index) => (
          <div
            key={index}
            className={`${rulesstyles.table_titles} ${
              index === 0
                ? rulesstyles.table_titles_first
                : rulesstyles.table_titles_other
            }`}
            style={{
              width: `${100 / titles.length}%`,
            }}>
            {/* <Text main fontSize={theme.fontSize.s}>
              {title}
            </Text> */}
            {/* 单词要换行 */}
            <div className="whitespace-pre-wrap">
              {title?.split(' ').join('\n')}
            </div>
            {/* <div>{title?.split(' ').join('\n')}</div> */}
          </div>
        ))}
      </View>
      {results.map((result, index) => (
        <View
          key={index}
          style={[
            rulesStyle.tableItem,
            theme.flex.row,
            theme.flex.between,
            theme.flex.centerByCol,
            theme.padding.s,
            index % 2 === 1 ? rulesStyle.tableItemLight : null,
          ]}>
          {result.map((col, innerIndex) => (
            <div
              key={innerIndex}
              style={{
                ...(innerIndex === 0
                  ? rulesStyle.firstCol
                  : rulesStyle.otherCol),
                ...theme.flex.center,
                width: `${100 / result.length}%`,
                // ...resultColStyles[innerIndex],
              }}>
              {typeof col === 'string' ? (
                <Text
                  second
                  fontSize={theme.fontSize.s}
                  style={[
                    theme.font.center,
                    innerIndex === 0
                      ? rulesStyle.firstCol
                      : rulesStyle.otherCol,
                  ]}>
                  {col}
                </Text>
              ) : (
                col
              )}
            </div>
          ))}
        </View>
      ))}
    </View>
  );
};

export default ProxyRulesTable;
